<template>
  <div class="container login">
    <div class="login-bg">
      <img :src="require('@/assets/login_bg_011.jpg')" alt="" />
    </div>
    <p class="title">欢迎登录</p>
    <div class="login-form">
      <van-form @submit="onSubmit">
        <van-field
          v-model="loginData.phone"
          name="phone"
          label="手机号"
          placeholder="请输入手机号码"
          type="tel"
          maxlength="11"
        />
        <van-field
          v-model="loginData.captcha"
          center
          clearable
          type="captcha"
          name="captcha"
          label="短信验证码"
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button
              size="small"
              type="info"
              native-type="button"
              @click="verificationCode"
              :disabled="isSmsSend"
              >{{ sendBtnText }}</van-button
            >
          </template>
        </van-field>
        <!-- <div class="forget-password">
          <span @click="handleForgetPassword">忘记密码?</span>
        </div> -->
        <div style="margin: 16px">
          <van-button
            :loading="subStatus"
            round
            block
            type="primary"
            native-type="submit"
            loading-text="登录中..."
          >
            登录
          </van-button>
        </div>
      </van-form>
    </div>
    <div class="version">
      <span>{{ "Ver: " + versions }}</span>
    </div>
  </div>
</template>
<script>
import { phone_captcha, send } from "@/api/user";
import version from "../../package.json";
export default {
  data() {
    return {
      loginData: {
        phone: "",
        captcha: "",
        openid: "",
      },
      versions: "",
      subStatus: false,
      isSmsSend: false,
      sendBtnText: "发送验证码",
      timer: null,
      counter: 60,
    };
  },
  created() {
    this.loginData.openid = this.$route.params.openid;
    this.versions = version.version;
    console.log(this.$route.params, "微信登录页面传值");
  },
  methods: {
    // 登录
    onSubmit(val) {
      console.log(this.$route.params.redirect, "登录跳转路径");
      if (val.phone.trim() === "") {
        this.subStatus = false;
        this.$toast("请输入手机号码");
        return;
      }
      if (
        !/^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
          val.phone
        )
      ) {
        this.subStatus = false;
        this.$toast("手机号码输入不正确");
        return;
      }
      if (val.captcha.trim() === "") {
        this.subStatus = false;
        this.$toast("请输入验证码");
        return;
      }
      this.subStatus = true;
      phone_captcha(this.loginData)
        .then((res) => {
          this.subStatus = false;
          // console.log("登录: ", res);
          if (res.code === 0) {
            localStorage.setItem("myToken", res.result.token);
            if (JSON.stringify(this.$route.params) == "{}") {
              this.$router.replace("/");
            } else {
              this.$router.replace(this.$route.params.redirect);
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.subStatus = false;
        });
    },
    // 发送验证码
    verificationCode() {
      this.isSmsSend = true;
      send(this.loginData.phone)
        .then((res) => {
          // console.log("验证码", res);
          if (res.code === 0) {
            this.countDown();
            this.$toast("已发送验证码");
          }else{
            this.isSmsSend = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.isSmsSend = false;
        });
    },
    // 验证码倒计时
    countDown() {
      // 将setInterval()方法赋值给前面定义的timer计时器对象，等用clearInterval()方法时方便清空这个计时器对象
      this.timer = setInterval(() => {
        // 替换文本，用es6里面的``这个来创建字符串模板，让秒实时改变
        this.sendBtnText = `(${this.counter}秒)后发送`;
        this.counter--;
        if (this.counter < 0) {
          // 当计时小于零时，取消该计时器
          clearInterval(this.timer);
          this.reset();
        }
      }, 1000);
    },
    // 重置倒计时
    reset() {
      // 重置按钮可用
      this.isSmsSend = false;
      // 重置文本内容
      this.sendBtnText = "点击发送验证码";
      if (this.timer) {
        // 存在计时器对象，则清除
        clearInterval(this.timer);
        // 重置秒数，防止下次混乱
        this.counter = 60;
        // 计时器对象重置为空
        this.timer = null;
      }
    },
    // 忘记密码
    handleForgetPassword() {
      this.$router.push({
        name: "Password",
        params: {
          openid: this.$route.params.openid,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.login {
  .login-bg {
    height: 220px;

    img {
      height: 100%;
      width: 100%;
    }
  }

  .title {
    font-size: 20px;
    font-weight: 600;
  }

  .login-form {
    width: 80%;
    margin: 0 auto;

    .forget-password {
      padding: 10px 0;
      text-align: right;
      color: #c5c5c5;
    }
  }
  .version {
    position: fixed;
    bottom: 15px;
    margin: auto;
    left: 0;
    right: 0;
  }
}
</style>
